<div class="utility-form-container fade-in">
    <!-- Bill Details View -->
    <div *ngIf="currentStep === 'details'" class="details-view-wrapper">
        <div class="content-card">
            <div class="modal-header">
                <h2 class="title">Bill Details</h2>
                <button class="close-btn" (click)="goBack()">
                    <img src="assets/icons/close-gray.png" alt="Close">
                </button>
            </div>
            <div class="modal-content">
                <div class="details-list">
                    <div class="detail-row">
                        <span class="label">Biller:</span>
                        <span class="value">{{billDetails.biller}}</span>
                    </div>
                    <div class="row-separator"></div>
                    <div class="detail-row">
                        <span class="label">Bill Period:</span>
                        <span class="value">{{billDetails.period}}</span>
                    </div>
                    <div class="row-separator"></div>
                    <div class="detail-row">
                        <span class="label">Due Date:</span>
                        <span class="value">{{billDetails.dueDate}}</span>
                    </div>
                    <div class="row-separator"></div>
                    <div class="detail-row">
                        <span class="label">Bill Amount:</span>
                        <span class="value">₹{{billDetails.amount}}</span>
                    </div>
                </div>

                <div class="amount-entry-section">
                    <span class="section-label">Amount to Pay</span>
                    <div class="amount-box">
                        <span class="amount">₹{{billDetails.amount}}</span>
                        <span class="currency">INR</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-card selector-card" [class.dropdown-active]="showCardDropdown">
            <div class="modal-content">
                <span class="section-label">Select card</span>
                <div class="card-preview-box">
                    <div class="card-details">
                        <span class="card-name">{{selectedCard.name}}</span>
                        <span class="card-number">**** {{selectedCard.lastFour}}</span>
                    </div>
                    <button class="change-action-btn" (click)="toggleCardDropdown(); $event.stopPropagation()">
                        <span>Change</span>
                        <div class="arrow-icon-wrapper" [class.rotated]="showCardDropdown">
                            <img src="assets/icons/direction-down01.svg" class="orange-chevron">
                        </div>
                    </button>

                    <!-- Card Dropdown List -->
                    <div class="card-dropdown-list" *ngIf="showCardDropdown" (click)="$event.stopPropagation()">
                        <div class="dropdown-header">
                            <span class="title">Select Card</span>
                        </div>
                        <div class="dropdown-scroll-area">
                            <div *ngFor="let card of paymentCards" class="dropdown-item"
                                [class.selected]="selectedCard.lastFour === card.lastFour" (click)="selectCard(card)">
                                <div class="icon-box">
                                    <img [src]="card.icon" alt="card">
                                </div>
                                <div class="card-info">
                                    <div class="name-row">
                                        <span class="name">{{card.name}}</span>
                                        <span class="status-badge"
                                            *ngIf="selectedCard.lastFour === card.lastFour">Active</span>
                                    </div>
                                    <span class="number">**** {{card.lastFour}}</span>
                                </div>
                                <div class="selected-tick" *ngIf="selectedCard.lastFour === card.lastFour">
                                    <img src="assets/icons/tick.svg" alt="selected">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dropdown-backdrop" *ngIf="showCardDropdown" (click)="showCardDropdown = false"></div>

            </div>
        </div>
    </div>

    <!-- Original Content Card for other steps -->
    <div class="content-card" *ngIf="currentStep !== 'details'">
        <!-- Header -->
        <div class="modal-header">
            <h2 class="title">{{currentStep === 'add-new' ? 'Add new' : category?.name}}</h2>
            <button class="close-btn" (click)="goBack()">
                <img src="assets/icons/close-gray.png" alt="Close">
            </button>
        </div>

        <div class="modal-content">
            <!-- Step: Recent Payments -->
            <div *ngIf="currentStep === 'recent'" class="step-view">
                <h3 class="section-title">Recent payments</h3>
                <div class="recent-list">
                    <div *ngFor="let item of recentPayments" class="payment-card active">
                        <div class="card-left">
                            <div class="icon-box">
                                <img [src]="item.icon" [alt]="item.billerName">
                            </div>
                            <div class="info">
                                <span class="biller">{{item.billerName}}</span>
                                <span class="subtext">Consumer ID: {{item.consumerId}}</span>
                            </div>
                        </div>
                        <div class="card-right">
                            <span class="bill-label">Last bill:</span>
                            <span class="amount">₹{{item.lastBill}}</span>
                        </div>
                    </div>
                </div>

                <button class="add-new-btn" (click)="setStep('add-new')">
                    Add new
                </button>
            </div>

            <!-- Step: Add New Biller -->
            <div *ngIf="currentStep === 'add-new'" class="step-view">
                <h3 class="section-title center">Add New Biller</h3>
                <div class="form-grid">
                    <div class="form-field-group">
                        <label>Biller Name</label>
                        <div class="select-wrapper">
                            <select [(ngModel)]="newBiller.name">
                                <option value="Tata Power">Tata Power</option>
                            </select>
                            <div class="dropdown-icon">
                                <img src="assets/icons/direction-down01.svg">
                            </div>
                        </div>
                    </div>
                    <div class="form-field-group">
                        <label>Consumer Number / Account ID</label>
                        <input type="text" [(ngModel)]="newBiller.consumerNumber" placeholder="Enter ID">
                    </div>
                    <div class="form-field-group full">
                        <label>State / City (if required)</label>
                        <input type="text" [(ngModel)]="newBiller.stateCity" placeholder="Enter State/City">
                    </div>
                </div>
                <p class="form-hint">We'll fetch your latest bill automatically</p>
            </div>

            <!-- Step: Success -->
            <div *ngIf="currentStep === 'success'" class="success-view-wrapper">
                <div class="step-view center">
                    <div class="status-box">
                        <div class="check-circle vibrant">
                            <img src="assets/icons/img_check-circle.svg" alt="Success">
                        </div>
                        <h2 class="status-title">Payment Successful!</h2>
                        <p class="status-text">Your payment for <strong>{{category?.name}}</strong> has been processed.
                        </p>
                        <button class="done-btn" (click)="close.emit()">Done</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer Actions -->
    <div class="modal-footer" *ngIf="currentStep !== 'success'">
        <button class="footer-btn secondary" (click)="goBack()">
            {{currentStep === 'details' ? 'Cancel' : 'Back'}}
        </button>
        <button class="footer-btn primary gradient" (click)="nextStep()">
            {{currentStep === 'add-new' ? 'Fetch Bill' : (currentStep === 'details' ? 'Send' : 'Next')}}
        </button>
    </div>
</div>